import { useEffect } from 'react';
import { clearTextSelection } from '../utils/clearTextSelection';

export function useModalSelectionGuard(isOpen) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    clearTextSelection();
    const frameId = window.requestAnimationFrame(clearTextSelection);
    const timeoutId = window.setTimeout(clearTextSelection, 50);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.clearTimeout(timeoutId);
    };
  }, [isOpen]);
}

export function preventModalOverlaySelection(event) {
  event.preventDefault();
}
